
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-success/story/[slug]",
      function () {
        return require("private-next-pages/customer-success/story/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-success/story/[slug]"])
      });
    }
  